export const Types = {
  GET_REQUEST: 'prizes/GET_REQUEST',
  GET_SUCCESS: 'prizes/GET_SUCCESS',
  GET_FAILURE: 'prizes/GET_FAILURE',

  GET_LIST_REQUEST: 'prizes/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'prizes/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'prizes/GET_LIST_FAILURE',

  CREATE_REQUEST: 'prizes/CREATE_REQUEST',
  CREATE_SUCCESS: 'prizes/CREATE_SUCCESS',
  CREATE_FAILURE: 'prizes/CREATE_FAILURE',

  UPDATE_REQUEST: 'prizes/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'prizes/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'prizes/UPDATE_FAILURE',

  DELETE_REQUEST: 'prizes/DELETE_REQUEST',
  DELETE_SUCCESS: 'prizes/DELETE_SUCCESS',
  DELETE_FAILURE: 'prizes/DELETE_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },
};

export default function prizes(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.payment.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.prizes.data,
        page: action.payload.prizes.meta.current_page,
        totals: action.payload.prizes.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    case Types.DELETE_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: true,
        },
      };
    case Types.DELETE_SUCCESS:
    case Types.DELETE_FAILURE:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getPrizeRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getPrizeSuccess: payment => ({
    type: Types.GET_SUCCESS,
    payload: { payment },
  }),

  getPrizeFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getPrizesRequest: (page = 1) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page },
  }),

  getPrizesSuccess: prizes => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { prizes },
  }),

  getPrizesFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  createPrizeRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createPrizeSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createPrizeFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updatePrizeRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updatePrizeSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updatePrizeFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deletePrizeRequest: id => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deletePrizeSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deletePrizeFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),
};
